<template>
  <el-card v-loading="loading">
    <template slot="header">
      Add To Do
    </template>
    <el-form :model="form" :rules="formRules" ref="form">
      <el-form-item label="Title" prop="title">
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="Details" prop="detail">
        <el-input v-model="form.detail"></el-input>
      </el-form-item>
      <el-form-item label="Due Date" prop="dueAt">
        <el-date-picker
          v-model="form.dueAt"
          type="date"
          placeholder="To be completed by">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="Customer" prop="customer">
        <el-select v-model="form.customer" :loading="loading">
          <el-option
            :key="customer._id"
            v-for="customer of customers"
            :value="customer._id"
            :label="customer.email"
          >
            {{ customer.company }} {{ customer.company ? '-' : '' }} {{ customer.email }}
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Manager" prop="assignedTo">
        <el-select v-model="form.assignedTo" :loading="loading">
          <el-option
            :key="manager.id"
            v-for="manager of managers"
            :value="manager.id"
            :label="manager.email"
          >
            {{ manager.email }} - {{ manager.firstName }} {{ manager.lastName }}
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button @click="addTodo">
          Save
        </el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import axios from 'axios';
import { AUTH_API_BASE, CUSTOMER_API_BASE, ADMIN_API_BASE } from '../env';

export default {
  name: 'AddTodo',
  async mounted() {
    this.loading = true;
    await this.getCustomers();
    await this.getManagers();
    this.loading = false;
  },
  data() {
    return {
      loading: false,
      form: {
        title: '',
        detail: '',
        createdBy: this.$keycloak.tokenParsed.email,
        facility: this.$root.state.facility,
        customer: '',
        dueAt: new Date(),
        assignedTo: '',
      },
      formRules: {
        title: [{
          required: true,
          message: 'Please input Title',
          trigger: ['blur', 'change'],
        }],
        detail: [{
          required: true,
          message: 'Please input Detail',
          trigger: ['blur', 'change'],
        }],
        assignedTo: [{
          required: true,
          message: 'Please select Manager',
          trigger: ['blur', 'change'],
        }],
      },
      customers: [],
      managers: [],
    };
  },
  methods: {
    async getManagers() {
      try {
        const response = await axios.get(`${AUTH_API_BASE}/managers`, {
          params: {
            ...(this.$root.state.facility ? { location: this.$root.state.facility } : {}),
          },
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });

        this.managers = response.data;
      } catch (err) {
        this.loading = false;
        this.$message.error({
          title: 'Error',
          message: err.response.data,
        });
      }
    },
    async getCustomers() {
      try {
        this.loading = true;
        const response = await axios.get(`${CUSTOMER_API_BASE}/customers/v1/facility/${this.$root.state.facility}`, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        this.loading = false;
        // eslint-disable-next-line no-console
        this.customers = response.data;
      } catch (err) {
        this.loading = false;
      }
    },
    async addTodo() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          try {
            const { title, detail, createdBy, createdAt, dueAt, assignedTo, facility, customer } = this.form;
            await axios.post(`${ADMIN_API_BASE}/todos`, {
              title,
              detail,
              createdBy,
              createdAt,
              dueAt,
              assignedTo,
              facility,
              ...(customer ? { customer } : {}),
            }, {
              headers: {
                Authorization: `Bearer ${this.$keycloak.token}`,
              },
            });
  
            this.$emit('done');
  
            this.$message.success({
              message: 'To Do added successfully',
            });
            this.loading = false;
          } catch (err) {
            this.loading = false;
            this.$message.error({
              message: err.response.data,
            });
          }
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/AddTodo.vue